var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "20px",
    viewBox: "0 0 28 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "flags / DO") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 28,
    height: 20,
    rx: 2
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "flags-/-DO",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("rect", {
    stroke: "#F5F5F5",
    strokeWidth: 0.5,
    x: 0.25,
    y: 0.25,
    width: 27.5,
    height: 19.5,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    fill: "#083D7A",
    mask: "url(#mask-2)",
    x: 0,
    y: 0,
    width: 12,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    fill: "#083D7A",
    mask: "url(#mask-2)",
    x: 16,
    y: 12,
    width: 12,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    fill: "#DF1E35",
    mask: "url(#mask-2)",
    x: 0,
    y: 12,
    width: 12,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    fill: "#DF1E35",
    mask: "url(#mask-2)",
    x: 16,
    y: 0,
    width: 12,
    height: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14,8 C12.8954305,8 12,8.8954305 12,10 C12,11.1045695 12.8954305,12 14,12 C15.1045695,12 16,11.1045695 16,10",
    id: "Oval-85",
    stroke: "#0F6D1A",
    strokeWidth: 0.666666667,
    mask: "url(#mask-2)",
    transform: "translate(14.000000, 10.000000) rotate(-45.000000) translate(-14.000000, -10.000000) "
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-85",
    fill: "#042F60",
    mask: "url(#mask-2)",
    cx: 14,
    cy: 10,
    r: 1
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDo);
export default __webpack_public_path__ + "static/media/DO.31de3333d329fbc6141d6276169f04ce.svg";
export { ForwardRef as ReactComponent };